import { Component, OnInit } from '@angular/core';
import * as HighCharts from 'highcharts';
import StockModule from 'highcharts/modules/stock';
import {ModalController} from '@ionic/angular';
import {Api, User} from '../../providers';

@Component({
  selector: 'app-ion-modal',
  templateUrl: './ion-modal.page.html',
  styleUrls: ['./ion-modal.page.scss'],
})
export class IonModalPage implements OnInit {
  public price:any;
  public lists:any;

  constructor( public api:Api, public user: User,public modalController: ModalController) {

  }
  public dismissModal() {
      // using the injected ModalController this page
      // can "dismiss" itself and optionally pass back data
      this.modalController.dismiss({
          'dismissed': true
      });
  }

  ngOnInit() {
    this.ionViewDidLoad()
  }
  ionViewDidLoad() {
      this.api.post("candlestick", {type: "h",pdid:this.price.priceData.id, userKey: this.user.account.userKey}).subscribe(res => {
          const data: any = res["data"]["dt"]
          this.lists= res["data"]["pl"]
          var ohlc = [],
              volume = [],
              dataLength = data.length,
              // set the allowed units for data grouping
              groupingUnits = [[
                  'week',                         // unit name
                  [1]                             // allowed multiples
              ], [
                  'month',
                  [1, 2, 3, 4, 6]
              ]],

              i = 0;

          for (i; i < dataLength; i += 1) {
              ohlc.push([
                  data[i][0], // the date
                  data[i][1], // open
                  data[i][2], // high
                  data[i][3], // low
                  data[i][4] // close
              ]);

              volume.push([
                  data[i][0], // the date
                  data[i][5] // the volume
              ]);
          }

          const s: any = [{
              type: 'candlestick',
              name: this.price.priceData.name,
              data: ohlc,
              // dataGrouping: {
              //     units: groupingUnits
              // }
          }];

         
          var highCharts: any = HighCharts
          
          StockModule(highCharts); // <-- Have to be first

          highCharts.setOptions({
            chart: {
                style: {
                    fontFamily: 'roya'
                }
            }
        });
          var myChart = new highCharts.chart('container', {

              rangeSelector: {
                  selected: 1
              },

              title: {
                  text: this.price.priceData.name
              },
              xAxis : {
                  categories: res["data"]["date"] ,
                  title: {
                      text:res["data"]["type"]
                  }
              },
              yAxis: [{
                  labels: {
                      align: 'middle',
                      x: -3
                  },
                  title: {
                      text: 'قیمت'
                  },
                  resize: {
                      enabled: true
                  }
              }],

              tooltip: {
                  split: true
              },
              series: s
          });
      })

    }
}
